import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  QuestionAnswerObject,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

import { DisplayQuestionConfig } from '@hyper-inferno/display-core';

export class DisplayHandler implements QuestionHandler<DisplayQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    return '';
  }
}
